const STAGING_PANEL_URL = 'https://new-demo-panel.askyogi.live/';
const LEGAL_DEV_PANEL_URL = 'https://legal-dev-panel.askyogi.live/';
const DEVELOPMENT_PANEL_URL = 'https://development-demo-panel.askyogi.live/';

export const getEnvironmentLabel = (backendUrl) => {
  if (!backendUrl) {
    return 'Demo-AskYogi';
  }

  const normalizedBackendUrl = backendUrl.trim();

  if (
    normalizedBackendUrl.includes('localhost') ||
    normalizedBackendUrl.includes('127.0.0.1')
  ) {
    return 'Demo-AskYogi (Local)';
  }

  if (
    normalizedBackendUrl.includes('legal-demo-api.askyogi.live') ||
    normalizedBackendUrl.includes('legal-demo')
  ) {
    return 'visacaste-stage';
  }

  if (
    normalizedBackendUrl.includes('new-demo-panel.askyogi.live') ||
    normalizedBackendUrl.includes('staging')
  ) {
    return 'Staging-AskYogi';
  }

  if (
    normalizedBackendUrl.includes('development-demo-panel.askyogi.live') ||
    (normalizedBackendUrl.includes('dev') &&
      !normalizedBackendUrl.includes('legal-demo'))
  ) {
    return 'Development-AskYogi';
  }

  if (normalizedBackendUrl.includes('prod')) {
    return 'Demo-AskYogi (Production)';
  }

  try {
    const url = new URL(normalizedBackendUrl);
    const hostname = url.hostname;
    return `Demo-AskYogi (${hostname})`;
  } catch (e) {
    return 'Demo-AskYogi';
  }
};

export const getEnvironmentLinks = (backendUrl) => {
  const normalizedBackendUrl = backendUrl ? backendUrl.trim() : '';

  const environments = [
    {
      label: 'Staging AskYogi',
      url: STAGING_PANEL_URL,
      matches: (url) =>
        url.includes('new-demo-panel.askyogi.live') || url.includes('staging'),
    },
    {
      label: 'visacaste-stage',
      url: LEGAL_DEV_PANEL_URL,
      matches: (url) => url.includes('legal-demo'),
    },
    {
      label: 'Development-AskYogi',
      url: DEVELOPMENT_PANEL_URL,
      matches: (url) =>
        url.includes('development-demo-panel.askyogi.live') ||
        (url.includes('dev') && !url.includes('legal-demo')),
    },
  ];

  return environments.filter((env) => {
    if (!normalizedBackendUrl) {
      return true;
    }
    return !env.matches(normalizedBackendUrl);
  });
};

